// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"8bbdbbfd25e94d65192b","883":"6d3738234f0971eee056"}[chunkId] + ".js";
};